import { render, staticRenderFns } from "./AskDownloadPass.vue?vue&type=template&id=95dc4644"
import script from "./AskDownloadPass.vue?vue&type=script&lang=js"
export * from "./AskDownloadPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports